export function truncate(str: string, n: number) {
  return str?.length > n ? str.slice(0, n - 1) + "..." : str;
}

export const mockAuthorId = "66b9c79a2c16413ab212cf7c";

export function capitalizeFirstLetter(string: string) {
  if (!string) {
    return "";
  }

  if (string === "firebase") {
    return "Apple Firebase";
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function truncateWithExpand(str: string, n: number) {
  let res = str;
  let isMoreText = false;

  if (str?.length > n) {
    res = str.slice(0, n - 1) + "...";
    isMoreText = true;
  }

  return {
    data: res,
    isMoreText: isMoreText,
  };
}

export function addZeroBeforeHours(num: number) {
  if (num >= 0 && num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}

export function getURLWithDomain(url: string) {
  if (!url) return "";

  let fileName = url;
  if (!url?.includes(process.env.REACT_APP_UPLOAD_URL ?? "")) {
    fileName = `${process.env.REACT_APP_UPLOAD_URL}/${url}`;
  }

  return fileName;
}

export function secondsToDhms(seconds: any, t: any) {
  if (!seconds) return;
  seconds = Number(seconds);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  var dDisplay = d > 0 ? d + (d == 1 ? ` ${t("day")} ` : ` ${t("days")} `) : "";
  var hDisplay =
    h > 0 ? h + (h == 1 ? `  ${t("hour")} ` : `  ${t("hours")} `) : "";
  //var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
  //var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
  return dDisplay + hDisplay;
}

export function removeLeadingSlash(url: string) {
  return url.replace(/^\/+/, "");
}

export function removeTrailingZero(value: string | number): string {
  const num = Number(value);
  
  if (Number.isNaN(num)) return "";

  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
}